module.exports = __webpack_public_path__ + "static/media/wir-suchen_1.b6ba1407.jpg";